import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./IgniteDashboard.css";

import IgniteNavbar from "../../layout/IgniteNavbar";
import IgniteHeader from "../../layout/IgniteHeader";

import JourneyProgressCard from "./Components/JourneyProgressCard";
import DailyStreakCard from "./Components/DailyStreakCard";
import RecentAssessmentCard from "./Components/RecentAssessmentCard";
import ContinueLearningCard from "./Components/ContinueLearningCard";
import LevelObjectivesCard from "./Components/LevelObjectivesCard";

import VaultProgressCard from "./Components/VaultProgressCard";


const IgniteDashboard = () => {
     useEffect(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, []);
   useEffect(() => {
    const navbar = document.querySelector("header, .navbar");
    const footer = document.querySelector("footer");

    // Hide navbar & footer
    if (navbar) navbar.style.display = "none";
    if (footer) footer.style.display = "none";

    // Restore when leaving page
    return () => {
      if (navbar) navbar.style.display = "";
      if (footer) footer.style.display = "";
    };
  }, []);

    const email =
        localStorage.getItem("user_email");

    const [dashboardData, setDashboardData] =
        useState(null);

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");

    useEffect(() => {

        if (!email) {

            setLoading(false);

            setError("User email not found.");

            return;

        }

        fetchDashboard();

    }, []);

    const fetchDashboard = async () => {

        try {

            setLoading(true);

            const response =
                await axios.get(

                    `/api/dashboard/${email}`

                );

            setDashboardData(
                response.data
            );

        }

        catch (err) {

            console.error(err);

            setError(

                "Unable to load dashboard."

            );

        }

        finally {

            setLoading(false);

        }

    };

    if (loading) {

        return (

            <div className="ignite-dashboard-loading">

                Loading Dashboard...

            </div>

        );

    }

    if (error) {

        return (

            <div className="ignite-dashboard-error">

                {error}

            </div>

        );

    }

    return (

        <div className="ignite-dashboard">

            <IgniteNavbar />

            <main className="ignite-dashboard-main">

                <IgniteHeader

                    title="Dashboard"

                    subtitle="Continue your Ignite journey."

                />

                <section className="dashboard-body">

                    <div className="dashboard-row">

                        <JourneyProgressCard
                            data={dashboardData}
                        />

                        <DailyStreakCard
                            data={dashboardData}
                        />

                    </div>

                    <div className="dashboard-row">

                        <RecentAssessmentCard
                            data={dashboardData}
                        />

                        <ContinueLearningCard
                            data={dashboardData}
                        />

                    </div>

                    <div className="dashboard-row">

                        <LevelObjectivesCard />

                        <VaultProgressCard
                            data={dashboardData}
                        />

                    </div>
                    
                                    
                </section>

            </main>

        </div>

    );

};

export default IgniteDashboard;